module.exports = __webpack_public_path__ + "static/media/HAUX_TERMO_RESPONSABILIDADE_AVALIACAO_FISICA.15785b2c.pdf";